var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom/24/zoom-in"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M9.69526 7.91429C9.69526 6.93068 8.89789 6.13331 7.91429 6.13331C6.93068 6.13331 6.13331 6.93068 6.13331 7.91429C6.13331 8.89789 6.93068 9.69526 7.91429 9.69526C8.34876 9.69526 8.7465 9.5392 9.05563 9.28071C9.08385 9.23644 9.11724 9.19455 9.15589 9.15589C9.19455 9.11724 9.23644 9.08385 9.28071 9.05563C9.5392 8.7465 9.69526 8.34876 9.69526 7.91429ZM11.1619 7.91429C11.1619 8.54546 10.9812 9.13414 10.6696 9.63265L11.7852 10.7482C12.0716 11.0346 12.0716 11.4988 11.7852 11.7852C11.4988 12.0716 11.0346 12.0716 10.7482 11.7852L9.63265 10.6696C9.13414 10.9812 8.54546 11.1619 7.91429 11.1619C6.12065 11.1619 4.66662 9.70792 4.66662 7.91429C4.66662 6.12065 6.12065 4.66662 7.91429 4.66662C9.70792 4.66662 11.1619 6.12065 11.1619 7.91429Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomIn);
export default __webpack_public_path__ + "static/media/icon-zoom-in.5bdf26d932a995a6392112fa4dd2d0ff.svg";
export { ForwardRef as ReactComponent };